import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogClose, MatDialogRef} from '@angular/material/dialog';
import {MatFormField, MatFormFieldModule} from '@angular/material/form-field';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {JsonPipe, NgTemplateOutlet} from '@angular/common';
import {MatAutocomplete, MatAutocompleteTrigger, MatOption} from '@angular/material/autocomplete';
import {MatSelect} from '@angular/material/select';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {IsEnabledDirective} from '../../../../core/directives/is-enabled.directive';
import {
  AccessDeniedMessageComponent
} from '../../../../shared/components/access-denied-message/access-denied-message.component';
import {IndexItemsListComponent} from '../../index-entity/index-items-list/index-items-list.component';
import {MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle} from '@angular/material/expansion';
import {UnitSelectorComponent} from '../../index-entity/unit-selector/unit-selector.component';
import {GroupService, IndicatorService,} from '../../../apiModule1';
import {MultiSelect3Component} from '../../../../shared/components/multi-select3/multi-select3.component';
import {FillingMethodComponent} from '../../index-entity/filling-method/filling-method.component';
import {ChoiseComponent} from '../../../../shared/components/choise/choise.component';
import {MultiSelect2Component} from '../../../../shared/components/multi-select2/multi-select2.component';
import {map} from 'rxjs/operators';


@Component({
    standalone: true,
    selector: 'pas-dialog-group',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss', '../../index-entity/dialog/dialog.component.scss', '../../index-entity/filling-method/filling-method.component.scss'],
    imports: [
        MatFormField,
        MatDialogClose,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        JsonPipe,
        MatAutocomplete,
        MatOption,
        ReactiveFormsModule,
        MatAutocompleteTrigger,
        MatSelect,
        AccessDeniedMessageComponent,
        IsEnabledDirective,
        MatIcon,
        MatIconButton,
        IndexItemsListComponent,
        MatButton,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        MatExpansionPanelTitle,
        NgTemplateOutlet,
        UnitSelectorComponent,
        MultiSelect3Component,
        FillingMethodComponent,
        ChoiseComponent,
        MultiSelect2Component,
    ],
})
export class DialogComponent implements OnInit {

    isNew: boolean = false;

    form = new FormGroup({
        name: new FormControl<string>('',[Validators.required]),
        shortName: new FormControl<string>('',[Validators.required]),
        object: new FormControl<boolean>(false,[Validators.required]),
        indicator: new FormControl<Indicator[]|null>(null,[Validators.required]),
    })
    isEnabled: boolean = false;


    indicator: Indicator = {} as Indicator;

    constructor(
        public dialogRef: MatDialogRef<DialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Record<string, any>,
        public dataService: GroupService,
        public indicatorService: IndicatorService
    ) {
        this.isNew = data['isNew'];
        console.log('isNew', this.isNew, this.data);

        if (!this.isNew) {
            (this.dataService as any)['apiGroupIdGet']({id: this.data['id']}).subscribe((group: Group) => {
                console.log('group', group);
                if (!group) return;
                group.name && this.form.get('name')!.setValue(group.name);
                group.shortName && this.form.get('shortName')!.setValue(group.shortName);
                group.indicators && this.form.get('indicator')!.setValue(group.indicators);
                group.object && this.form.get('object')!.setValue(group.object);
            })
        }
    }


    onNoClick(): void {
        this.dialogRef.close();
    }

    onApply() {
      if(this.form.invalid) return;
        const returnData: Group = {
            id: this.data['id'] || 0,
            name: this.form.get('name')!.value || '',
            shortName: this.form.get('shortName')!.value || '',
            object: this.form.get('object')!.value || false,
            indicators: this.form.get('indicator')!.value || [],
        }
        this.dialogRef.close(returnData);
    }

    ngOnInit() {
        this.indicatorService.apiIndicatorGet({})
            .pipe(map(v => v.values))
            .subscribe((indicator: Indicator) => {
                this.indicator = indicator;
            })
    }
}

